// extracted by mini-css-extract-plugin
export default {"Popup":"Popup_Popup__u3Zxc","PopupFixed":"Popup_PopupFixed__bCEk9","Visible":"Popup_Visible__JJ-av","Text":"Popup_Text__k4eFp","Whale":"Popup_Whale__EDvr9"};